export default "__VITE_ASSET__CDYDPDmE__"